import throwEnvInvalidKeyPrefixError from '../../../Errors/Env/EnvInvalidKeyPrefix.error'
import throwEnvInvalidKeyTypeError from '../../../Errors/Env/EnvInvalidKeyType.error'
import throwEnvUndefinedValueError from '../../../Errors/Env/EnvUndefinedValue.error'
import throwEnvUnparseableJsonError from '../../../Errors/Env/EnvUnparseableJson.error'
import isString from '../../Is/String/IsString.support'

interface Options {
  key: any,
  numeric?: boolean,
  parse?: boolean,
}

const envGet = (options: Options) => {
  const {
    key,
    numeric = false,
    parse = false,
  } = options

  if (!isString(key)) {
    return throwEnvInvalidKeyTypeError(key)
  }
  if (!key.startsWith(`REACT_APP_`)) {
    return throwEnvInvalidKeyPrefixError(key)
  }
  let value = process.env[key]
  if (value === undefined) {
    return throwEnvUndefinedValueError(key)
  }
  if (parse) {
    try {
      value = JSON.parse(value)
    } catch (error) {
      return throwEnvUnparseableJsonError(key, value, error)
    }
  }
  if (numeric) {
    return Number(value)
  }
  return value
}

export default envGet
